/**
 * @desc 获取订单商品详情
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.SystemOrderItemParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsFlowSystemOrder/systemOrderItem/getOne`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
